const events0 = [
  { position: 3600 * 0.2, type: 'demand', visible: false, value: 20 },
  { position: 3600 * 0.4, type: 'demand', visible: false, value: 80 },
  { position: 3600 * 0.6, type: 'demand', visible: false, value: 80 },
  { position: 3600 * 0.8, type: 'demand', visible: false, value: 120 },
  { position: 3600 * 1.0, type: 'pump-damage', visible: false, pump: 1, repair: 450 },
  { position: 3600 * 1.1, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 1.2, type: 'pump-break', visible: false, pump: 1, repair: 600 },
  { position: 3600 * 1.3, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 1.5, type: 'demand', visible: false, value: -100 },
  { position: 3600 * 1.8, type: 'demand', visible: false, value: -80 },
  { position: 3600 * 2.2, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 2.6, type: 'demand', visible: false, value: 80 },
  { position: 3600 * 3.0, type: 'demand', visible: false, value: 80 },
  { position: 3600 * 3.1, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 3.2, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 4.3, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 5, type: 'sunrise' },
  { position: 3600 * 5.1, type: 'demand', visible: false, value: -70 },
  { position: 3600 * 5.5, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 10, type: 'rain', duration: 3600 },
  { position: 3600 * 12, type: 'sunny' },
  { position: 3600 * 12.1, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 15, type: 'storm', duration: 3 * 3600 },
  { position: 3600 * 15.1, type: 'demand', visible: false, value: -80 },
  { position: 3600 * 18.1, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 19.5, type: 'night' },
  { position: 3600 * 20.1, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 21.5, type: 'rain', duration: 3600 },
  { position: 3600 * 22, type: 'rate', visible: false, value: 0.07 }
]

const events1 = [
  { position: 3600 * 0.5, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 3, type: 'pump-damage', visible: false, pump: 0, repair: 200 },
  { position: 3600 * 4, type: 'pump-break', visible: false, pump: 0, repair: 600 },
  { position: 3600 * 5, type: 'sunrise' },
  { position: 3600 * 5.1, type: 'demand', visible: false, value: 80 },
  { position: 3600 * 6, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 6.1, type: 'demand', visible: false, value: 100 },
  { position: 3600 * 8, type: 'rain', duration: 3 * 3600 },
  { position: 3600 * 8.1, type: 'demand', visible: false, value: -70 },
  { position: 3600 * 10.5, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 11, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 12, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 13, type: 'sunny' },
  { position: 3600 * 13.1, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 14.5, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 14.7, type: 'demand', visible: false, value: -40 },
  { position: 3600 * 17.5, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 17.6, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 19.5, type: 'night' },
  { position: 3600 * 20.1, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 21.4, type: 'pump-damage', visible: false, pump: 0, repair: 200 },
  { position: 3600 * 21.5, type: 'rain', duration: 3600 },
  { position: 3600 * 22, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 22.1, type: 'demand', visible: false, value: -80 },
  { position: 3600 * 22.4, type: 'pump-break', visible: false, pump: 0, repair: 600 }
]

const events2 = [
  { position: 3600 * 3.1, type: 'pump-damage', visible: false, pump: 0, repair: 400 },
  { position: 3600 * 3.6, type: 'pump-break', visible: false, pump: 0, repair: 600, message: 'You should repair pump {pump.number}' },
  { position: 3600 * 5, type: 'sunrise' },
  { position: 3600 * 5.1, type: 'demand', visible: false, value: 100 },
  { position: 3600 * 6, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 9, type: 'sunny' },
  { position: 3600 * 9.1, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 10.5, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 10.1, type: 'demand', visible: false, value: -60 },
  { position: 3600 * 11.4, type: 'hot' },
  { position: 3600 * 11.5, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 11.9, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 12, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 12.2, type: 'demand', visible: false, value: 80 },
  { position: 3600 * 14.5, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 14.7, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 15, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 15.3, type: 'demand', visible: false, value: -30 },
  { position: 3600 * 15.5, type: 'cloudy', duration: 2 * 3600 },
  { position: 3600 * 15.6, type: 'demand', visible: false, value: -100 },
  { position: 3600 * 16, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 16.1, type: 'pump-damage', visible: false, pump: 0, repair: 400 },
  { position: 3600 * 16.6, type: 'pump-break', visible: false, pump: 0, repair: 600, message: 'You should repair pump {pump.number}. Next time, purchase analytics' },
  { position: 3600 * 17, type: 'sunny' },
  { position: 3600 * 17.1, type: 'demand', visible: false, value: 70 },
  { position: 3600 * 17.5, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 17.7, type: 'demand', visible: false, value: 70 },
  { position: 3600 * 18.5, type: 'cloudy', duration: 3600 },
  { position: 3600 * 18.6, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 19.6, type: 'demand', visible: false, value: 60 },
  { position: 3600 * 20.2, type: 'night' },
  { position: 3600 * 20.3, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 21.5, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 21.9, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 23, type: 'demand', visible: false, value: -50 }
]

const events3 = [
  { position: 3600 * 0.5, type: 'rain', duration: 3600 },
  { position: 3600 * 1, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 2, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 3, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 3.1, type: 'pump-damage', visible: false, pump: 0, repair: 440 },
  { position: 3600 * 3.9, type: 'pump-break', visible: false, pump: 0, repair: 600, message: 'You should repair pump {pump.number}. Next time, purchase analytics' },
  { position: 3600 * 3.5, type: 'storm', duration: 3600 * 3 },
  { position: 3600 * 5, type: 'sunrise' },
  { position: 3600 * 5.1, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 5.2, type: 'pump-damage', visible: false, pump: 0, repair: 440 },
  { position: 3600 * 5.7, type: 'pump-break', visible: false, pump: 0, repair: 600, message: 'You should repair pump {pump.number}. Next time, purchase analytics' },
  { position: 3600 * 6, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 6.5, type: 'demand', visible: false, value: 100 },
  { position: 3600 * 7, type: 'cloudy', duration: 3600 * 2.75 },
  { position: 3600 * 7.1, type: 'demand', visible: false, value: -40 },
  { position: 3600 * 8, type: 'pump-damage', visible: false, pump: 0, repair: 440 },
  { position: 3600 * 8.5, type: 'pump-break', visible: false, pump: 0, repair: 600, message: 'You should repair pump {pump.number}. Next time, purchase analytics' },
  { position: 3600 * 9.2, type: 'demand', visible: false, value: -100 },
  { position: 3600 * 10, type: 'sunny' },
  { position: 3600 * 10.1, type: 'demand', visible: false, value: 80 },
  { position: 3600 * 10.5, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 10.6, type: 'demand', visible: false, value: 30 },
  { position: 3600 * 11.5, type: 'demand', visible: false, value: 50 },
  { position: 3600 * 12, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 12.2, type: 'rain', duration: 3600 * 3 },
  { position: 3600 * 12.4, type: 'demand', visible: false, value: -60 },
  { position: 3600 * 12.9, type: 'demand', visible: false, value: -60 },
  { position: 3600 * 13, type: 'pump-damage', visible: false, pump: 0, repair: 440 },
  { position: 3600 * 13.5, type: 'pump-break', visible: false, pump: 0, repair: 600, message: 'You should repair pump {pump.number}. Yep, the pumps are in trouble. Analytics will help!' },
  { position: 3600 * 14, type: 'demand', visible: false, value: -80 },
  { position: 3600 * 14.5, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 15.2, type: 'cloudy', duration: 3600 * 3 },
  { position: 3600 * 15.8, type: 'pump-damage', visible: false, pump: 0, repair: 440 },
  { position: 3600 * 16, type: 'demand', visible: false, value: -50 },
  { position: 3600 * 16.3, type: 'pump-break', visible: false, pump: 0, repair: 600, message: 'You should repair pump {pump.number}. Yep, the pumps are in trouble. Analytics will help!' },
  { position: 3600 * 17.2, type: 'pump-damage', visible: false, pump: 0, repair: 440 },
  { position: 3600 * 17.5, type: 'rate', visible: false, value: 0.15 },
  { position: 3600 * 17.6, type: 'pump-break', visible: false, pump: 0, repair: 600, message: 'You should repair pump {pump.number}. Yep, the pumps are in trouble. Analytics will help!' },
  { position: 3600 * 18, type: 'demand', visible: false, value: 80 },
  { position: 3600 * 18.2, type: 'sunny' },
  { position: 3600 * 19, type: 'demand', visible: false, value: 60 },
  { position: 3600 * 20, type: 'night' },
  { position: 3600 * 20.6, type: 'demand', visible: false, value: 30 },
  { position: 3600 * 21.4, type: 'pump-damage', visible: false, pump: 0, repair: 400 },
  { position: 3600 * 21.5, type: 'cloudy', duration: 3600 * 3 },
  { position: 3600 * 21.8, type: 'demand', visible: false, value: -60 },
  { position: 3600 * 21.9, type: 'pump-break', visible: false, pump: 0, repair: 600, message: 'You should repair pump {pump.number}. Yep, the pumps are in trouble. Analytics will help!' },
  { position: 3600 * 22, type: 'rate', visible: false, value: 0.07 },
  { position: 3600 * 22.5, type: 'demand', visible: false, value: -80 },
  { position: 3600 * 23, type: 'demand', visible: false, value: -40 }
]

export default [
  events0,
  events1,
  events2,
  events3
]
